import SEO from "@/components/SEO";
import { Link } from "react-router-dom";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/pages/home/components/Footer";

const funcionalidades = [
  {
    icon: "ri-file-music-line",
    titulo: "Partituras em Tela Cheia",
    descricao: "Abra qualquer partitura comprada ou da sua playlist direto no iPad em tela cheia, com zoom preciso e modo paisagem otimizado para palco e ensaios.",
    cor: "text-godoy-gold",
    bg: "bg-godoy-gold/10",
  },
  {
    icon: "ri-upload-cloud-line",
    titulo: "Upload de PDFs Pessoais",
    descricao: "Suba suas próprias partituras diretamente do app e organize tudo na sua playlist personalizada. disponível offline após o download.",
    cor: "text-emerald-400",
    bg: "bg-emerald-500/10",
  },
  {
    icon: "ri-time-line",
    titulo: "Metrônomo Profissional",
    descricao: "Metrônomo visual e sonoro integrado com BPM ajustável, subdivisões, compassos e marcação de tempo para estudo e performance.",
    cor: "text-blue-400",
    bg: "bg-blue-500/10",
  },
  {
    icon: "ri-drum-line",
    titulo: "Pads de Samples",
    descricao: "Pads personalizáveis para disparar sons em tempo real. Segure qualquer pad para abrir o menu de timbres. selecione da biblioteca ou suba seu próprio áudio.",
    cor: "text-purple-400",
    bg: "bg-purple-500/10",
  },
  {
    icon: "ri-play-list-line",
    titulo: "Playlists Inteligentes",
    descricao: "Organize suas partituras em setlists por culto, ensaio ou evento. Navegue entre as páginas com um toque enquanto toca.",
    cor: "text-rose-400",
    bg: "bg-rose-500/10",
  },
  {
    icon: "ri-shopping-bag-line",
    titulo: "Loja Integrada",
    descricao: "Compre novas partituras e cursos diretamente pelo app sem sair da plataforma. Tudo sincronizado com sua conta no site.",
    cor: "text-amber-400",
    bg: "bg-amber-500/10",
  },
];

const plataformas = [
  {
    nome: "App Store",
    subtitulo: "Disponível em breve para iPad & iPhone",
    icon: "ri-apple-line",
    badge: "iOS / iPadOS",
    cor: "border-godoy-gray/30 hover:border-godoy-gold/40",
  },
  {
    nome: "Google Play",
    subtitulo: "Disponível em breve para Android",
    icon: "ri-google-play-line",
    badge: "Android",
    cor: "border-godoy-gray/30 hover:border-godoy-gold/40",
  },
];

export default function AppPage() {
  return (
    <>
      <SEO
        title="GodoyProd App — Em Breve"
        description="O app GodoyProd para músicos de verdade. Partituras em tela cheia no iPad, metrônomo, pads de samples, playlists e muito mais. Em breve na App Store e Google Play."
        keywords="app GodoyProd, partituras iPad, metrônomo, pads samples, app para músicos"
        canonicalPath="/app"
      />
      <div className="min-h-screen bg-godoy-black">
        <Navbar />

        {/* Hero */}
        <section className="pt-32 pb-16 md:pt-44 md:pb-24">
          <div className="w-full px-6 md:px-10 lg:px-16 max-w-5xl mx-auto">
            <div className="flex flex-col md:flex-row items-center gap-10 md:gap-16">
              <div className="flex-1">
                <span className="inline-flex items-center gap-2 px-3 py-1.5 bg-godoy-gold/10 border border-godoy-gold/30 rounded-full text-godoy-gold text-xs font-semibold tracking-wider uppercase mb-6">
                  <span className="w-2 h-2 rounded-full bg-godoy-gold animate-pulse" />
                  Em Desenvolvimento
                </span>
                <h1 className="font-serif text-4xl md:text-5xl lg:text-6xl font-bold text-godoy-cream leading-tight mb-5">
                  O App para<br />
                  <span className="text-godoy-gold">Músicos</span>
                </h1>
                <p className="text-godoy-lightgray text-lg leading-relaxed mb-8 max-w-lg">
                  Tudo que você precisa no palco, no ensaio e no estudo. partituras, metrônomo, pads e sua biblioteca completa na palma da mão.
                </p>

                {/* Badges das lojas */}
                <div className="flex flex-col sm:flex-row gap-4">
                  {plataformas.map((p) => (
                    <div
                      key={p.nome}
                      className={`flex items-center gap-4 px-5 py-4 bg-godoy-charcoal/60 border ${p.cor} rounded-xl transition-all cursor-default`}
                    >
                      <i className={`${p.icon} text-3xl text-godoy-cream`} />
                      <div>
                        <p className="text-godoy-cream font-semibold text-sm">{p.nome}</p>
                        <p className="text-godoy-lightgray/60 text-xs">{p.subtitulo}</p>
                      </div>
                      <span className="ml-auto text-xs px-2 py-0.5 bg-godoy-gold/10 text-godoy-gold rounded border border-godoy-gold/20 whitespace-nowrap">
                        {p.badge}
                      </span>
                    </div>
                  ))}
                </div>

                <p className="text-godoy-lightgray/50 text-xs mt-4">
                  <i className="ri-mail-line mr-1" />
                  Quer ser notificado quando lançar?{" "}
                  <Link to="/contato" className="text-godoy-gold hover:underline">
                    Entre em contato
                  </Link>
                </p>
              </div>

              {/* Visual decorativo */}
              <div className="flex-shrink-0 relative">
                <div className="w-56 h-56 md:w-72 md:h-72 rounded-3xl bg-gradient-to-br from-godoy-gold/20 to-godoy-gold/5 border border-godoy-gold/20 flex items-center justify-center relative overflow-hidden">
                  <div className="absolute inset-0 bg-gradient-to-br from-godoy-gold/10 to-transparent" />
                  <img
                    src="https://pub-bc092def332d4fb180f02b510802da8e.r2.dev/LogoGP.png"
                    alt="GodoyProd App"
                    className="w-28 md:w-36 object-contain relative z-10 opacity-90"
                  />
                  <div className="absolute -bottom-8 -right-8 w-32 h-32 rounded-full bg-godoy-gold/10 blur-2xl" />
                  <div className="absolute -top-6 -left-6 w-24 h-24 rounded-full bg-godoy-gold/5 blur-xl" />
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Funcionalidades */}
        <section className="py-16 md:py-24 border-t border-godoy-gray/10">
          <div className="w-full px-6 md:px-10 lg:px-16 max-w-5xl mx-auto">
            <div className="text-center mb-14">
              <span className="text-godoy-gold text-sm font-semibold tracking-widest uppercase">Funcionalidades</span>
              <h2 className="font-serif text-3xl md:text-4xl font-bold text-godoy-cream mt-3 mb-4">
                Tudo que um músico precisa
              </h2>
              <p className="text-godoy-lightgray max-w-xl mx-auto">
                Desenvolvido especificamente para músicos que atuam em igrejas e palcos.
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
              {funcionalidades.map((f) => (
                <div
                  key={f.titulo}
                  className="bg-godoy-charcoal/60 border border-godoy-gray/20 rounded-xl p-6 hover:border-godoy-gold/30 transition-all group"
                >
                  <div className={`w-12 h-12 ${f.bg} rounded-xl flex items-center justify-center mb-4`}>
                    <i className={`${f.icon} text-2xl ${f.cor}`} />
                  </div>
                  <h3 className="font-serif text-lg font-semibold text-godoy-cream mb-2 group-hover:text-godoy-gold transition-colors">
                    {f.titulo}
                  </h3>
                  <p className="text-godoy-lightgray text-sm leading-relaxed">{f.descricao}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Destaque iPad */}
        <section className="py-16 md:py-24 border-t border-godoy-gray/10">
          <div className="w-full px-6 md:px-10 lg:px-16 max-w-5xl mx-auto">
            <div className="bg-gradient-to-br from-godoy-charcoal/80 to-godoy-black border border-godoy-gold/20 rounded-2xl p-8 md:p-12">
              <div className="flex flex-col md:flex-row items-center gap-8">
                <div className="w-20 h-20 md:w-24 md:h-24 bg-godoy-gold/10 rounded-2xl flex items-center justify-center flex-shrink-0 border border-godoy-gold/20">
                  <i className="ri-ipad-line text-4xl md:text-5xl text-godoy-gold" />
                </div>
                <div className="flex-1 text-center md:text-left">
                  <h3 className="font-serif text-2xl md:text-3xl font-bold text-godoy-cream mb-3">
                    Otimizado para iPad
                  </h3>
                  <p className="text-godoy-lightgray leading-relaxed mb-4">
                    A tela do iPad foi feita para partituras. O app GodoyProd aproveita cada centímetro. visualize a partitura inteira em tela cheia, sem distrações, com rolagem automática e modo noturno para ambientes com pouca luz.
                  </p>
                  <div className="flex flex-wrap gap-2 justify-center md:justify-start">
                    {["Tela cheia", "Modo noturno", "Zoom preciso", "Rolagem automática", "Modo offline"].map((tag) => (
                      <span key={tag} className="px-3 py-1 bg-godoy-gold/10 text-godoy-gold text-xs rounded-full border border-godoy-gold/20">
                        {tag}
                      </span>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Pads de samples */}
        <section className="py-16 md:py-24 border-t border-godoy-gray/10">
          <div className="w-full px-6 md:px-10 lg:px-16 max-w-5xl mx-auto">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-10 items-center">
              <div>
                <span className="text-godoy-gold text-sm font-semibold tracking-widest uppercase">Pads de Samples</span>
                <h2 className="font-serif text-3xl font-bold text-godoy-cream mt-3 mb-4">
                  Seus sons,<br />do seu jeito
                </h2>
                <p className="text-godoy-lightgray leading-relaxed mb-6">
                  Grade de pads personalizáveis para disparar samples em tempo real. Cada pad pode ter seu próprio timbre. segure o pad para abrir o menu e escolha entre os sons da biblioteca ou suba seu próprio arquivo de áudio direto do dispositivo.
                </p>
                <ul className="space-y-3">
                  {[
                    "Segure o pad para trocar o timbre",
                    "Suba áudios dos seus arquivos",
                    "Escolha entre timbres da plataforma",
                    "Volume individual por pad",
                    "Grupos de pads por setlist",
                  ].map((item) => (
                    <li key={item} className="flex items-center gap-3 text-sm text-godoy-lightgray">
                      <i className="ri-check-line text-godoy-gold" />
                      {item}
                    </li>
                  ))}
                </ul>
              </div>

              {/* Grid visual de pads */}
              <div className="grid grid-cols-3 gap-3">
                {["Kick", "Snare", "Hi-Hat", "Pad 1", "Pad 2", "Pad 3", "FX 1", "FX 2", "FX 3"].map((pad, i) => (
                  <div
                    key={pad}
                    className={`aspect-square rounded-xl border flex flex-col items-center justify-center gap-1 transition-all cursor-default ${
                      i === 0
                        ? "bg-godoy-gold/15 border-godoy-gold/40 text-godoy-gold"
                        : i === 4
                        ? "bg-purple-500/10 border-purple-500/30 text-purple-400"
                        : "bg-godoy-charcoal/60 border-godoy-gray/30 text-godoy-lightgray/60"
                    }`}
                  >
                    <i className="ri-drum-line text-xl" />
                    <span className="text-xs font-medium">{pad}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>

        {/* CTA final */}
        <section className="py-16 md:py-24 border-t border-godoy-gray/10">
          <div className="w-full px-6 md:px-10 lg:px-16 max-w-3xl mx-auto text-center">
            <h2 className="font-serif text-3xl md:text-4xl font-bold text-godoy-cream mb-4">
              Fique por dentro do lançamento
            </h2>
            <p className="text-godoy-lightgray mb-8 max-w-lg mx-auto">
              O app está em desenvolvimento. Crie sua conta agora para garantir acesso antecipado e ter sua biblioteca pronta quando o app for lançado.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Link
                to="/login"
                className="px-8 py-3.5 bg-godoy-gold text-godoy-black font-bold rounded-xl hover:bg-godoy-goldlight transition-all text-sm flex items-center justify-center gap-2"
              >
                <i className="ri-user-add-line" />
                Criar Conta Gratuita
              </Link>
              <Link
                to="/biblioteca"
                className="px-8 py-3.5 border border-godoy-gray/40 text-godoy-cream rounded-xl hover:border-godoy-gold/40 hover:text-godoy-gold transition-all text-sm flex items-center justify-center gap-2"
              >
                <i className="ri-book-open-line" />
                Explorar Partituras
              </Link>
            </div>
          </div>
        </section>

        <Footer />
      </div>
    </>
  );
}